import { curry } from 'lodash';
import { CustomerFacingEmail } from 'common/modules/emails/types';
import { CUSTOMER_FACING_EMAILS } from 'common/modules/emails/constants';
import { TFunction } from 'react-i18next';

const {
	adminOrderConfirmation,
	instoreOrderContract,
	extensionLinkConfirmation,
	depositReserved,
	depositReservationFailed,
	depositCaptured,
	onlineOrderConfirmation,
} = CUSTOMER_FACING_EMAILS;

export interface EmailTypeDetails {
	heading: string;
	description: string;
	emailType: CustomerFacingEmail;
	isEnabled?: boolean;
}

export const getEmailTypeDetails = curry(
	(t: TFunction, emailType: CustomerFacingEmail): EmailTypeDetails => {
		return (
			{
				[adminOrderConfirmation]: {
					heading: t(
						'emails.test.types.adminOrderConfirmation.heading',
						'Admin order confirmation',
					),
					description: t(
						'emails.test.types.adminOrderConfirmation.description',
						'Sent after successfully placed Admin order',
					),
					emailType: adminOrderConfirmation,
				},
				[onlineOrderConfirmation]: {
					heading: t(
						'emails.test.types.onlineOrderConfirmation.heading',
						'Online order confirmation',
					),
					description: t(
						'emails.test.types.onlineOrderConfirmation.description',
						'Sent after successfully placed Online order',
					),
					emailType: onlineOrderConfirmation,
				},
				[instoreOrderContract]: {
					heading: t('emails.test.types.instoreOrderContract.heading', 'Check-in order contract'),
					description: t(
						'emails.test.types.instoreOrderContract.description',
						'Sent after an order made from check-in is started',
					),
					emailType: instoreOrderContract,
				},
				[extensionLinkConfirmation]: {
					heading: t('emails.test.types.extensionLinkConfirmation.heading', 'Extension confirm'),
					description: t(
						'emails.test.types.extensionLinkConfirmation.description',
						'Sent after successful order extension',
					),
					emailType: extensionLinkConfirmation,
				},
				[depositReserved]: {
					heading: t('emails.test.types.depositReserved.heading', 'Deposit reservation'),
					description: t(
						'emails.test.types.depositReserved.description',
						'Sent after a successful deposit reservation',
					),
					emailType: depositReserved,
				},
				[depositReservationFailed]: {
					heading: t(
						'emails.test.types.depositReservationFailed.heading',
						'Failed to reserve deposit',
					),
					description: t(
						'emails.test.types.depositReservationFailed.description',
						'Sent if the deposit reservation failed',
					),
					emailType: depositReservationFailed,
				},
				[depositCaptured]: {
					heading: t('emails.test.types.depositCaptured.heading', 'Capture deposit'),
					description: t(
						'emails.test.types.depositCaptured.description',
						'Sent if the deposit was manually charged',
					),
					emailType: depositCaptured,
				},
			}[emailType] ?? { heading: '', description: '', emailType: '' }
		);
	},
);
